import {User}									from '../user/interface';
import {ApiCompanyState}						from './interface';

import * as API									from '../../ressources/API';


export default {
	getCompanyApi: async (user: User) => {
		const response = await API.getCompany(user);
		if (!response || !response.status)
			return null;
		return response.data;
	},
	putCompanyApi: async (data: ApiCompanyState) => {
		const response = await API.putCompany(data.idCompany, data.data, data.user);
		if (!response || !response.status)
			return null;
		return response.data;
	}
};
